import { Component, OnInit } from "@angular/core"
import { ActivatedRoute } from "@angular/router"
import { GTMService } from "../services/gtm.service"
import { UserService } from "../services/user.service"
import { Title } from "@angular/platform-browser"
import { PBSLM_TITLE } from "../models/constants"

declare var window: any

@Component({
    templateUrl: "./error.component.html",
    styleUrls: ["./error.component.less"],
})
export class ErrorComponent implements OnInit {
    public errorCode: string = null
    public image401: string = null
    public image404: string = null
    public image500: string = null
    public isStudent: boolean = false
    public nextURL: string = null
    public customMessage: string = null

    constructor(
        private route: ActivatedRoute,
        private userService: UserService,
        private gtmService: GTMService,
        private titleService: Title
    ) {
        this.image401 = require("../../assets/401error.png")
        this.image404 = require("../../assets/404error.png")
        this.image500 = require("../../assets/500error.png")

        this.isStudent = this.userService.hasStudentExperience()
    }

    public ngOnInit() {
        // TODO: When we'll have router links to embedded pages (tools)
        // make sure we reset the "PBSLM.ERROR_CODE" variable or check the url so that we don't loop infinitely.
        this.route.queryParamMap.subscribe((params) => {
            this.errorCode = params.get("status") || "404"
            this.nextURL = params.get("next") || null
            this.titleService.setTitle(
                `Error ${this.errorCode} | ${PBSLM_TITLE}`
            )
            this.gtmService.pushEvent(`Error${this.errorCode}`)
            this.gtmService.resetDataLayer()
            this.gtmService.pushPageView()
        })

        if (window.PBSLM.NG.ERROR_MESSAGE) {
            this.customMessage = window.PBSLM.NG.ERROR_MESSAGE
            window.PBSLM.NG.ERROR_MESSAGE = null
        }
    }
}
